module.exports = __webpack_public_path__ + "../resources/img/ic_re_full_charged_solid.1455382b.svg";